import { useSelector } from 'react-redux';

import { selectOrganisationId } from 'reduxLocal/slices/authSlice';

import { TableLayout } from 'components/ui/templates/TableLayout/TableLayout';

import { CollectionOrdersHeader } from './CollectionOrdersHeader';
import { CollectionOrdersTable } from './CollectionOrdersTable';
import { useLocalState } from './localState';

export function Orders() {
  const organisationId = useSelector(selectOrganisationId);
  if (!organisationId) throw new Error('Missing organisation id');

  const {
    state: localState,
    dispatch,
    updateCursorAfter,
    updateAccountNumber,
    updateStatusAndReasonCode,
    reset
  } = useLocalState();

  return (
    <TableLayout
      header={
        <CollectionOrdersHeader
          updateStatusAndReasonCode={updateStatusAndReasonCode}
          dispatch={dispatch}
          filters={localState.filters}
          updateAccountNumber={updateAccountNumber}
          reset={reset}
        />
      }
      content={
        <CollectionOrdersTable
          localState={localState}
          updateCursorAfter={updateCursorAfter}
        />
      }
    />
  );
}
